import React, { useState } from "react";
import AdBanner from "./AdBanner";

/* ─────────────────────────────────────────
   Componente de modal genérico
───────────────────────────────────────── */
function Modal({ title, onClose, children }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px 16px calc(env(safe-area-inset-bottom, 0px) + 16px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "var(--bg-card)",
          border: "1px solid var(--border)",
          borderRadius: 20,
          width: "100%",
          maxWidth: 520,
          maxHeight: "80vh",
          overflowY: "auto",
          padding: 28,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <h2
            style={{
              fontFamily: "'Bebas Neue'",
              fontSize: "1.8rem",
              letterSpacing: "0.06em",
              color: "var(--accent)",
            }}
          >
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "var(--text-secondary)",
              fontSize: "1.4rem",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>
        <div
          style={{
            color: "var(--text-secondary)",
            fontSize: "0.85rem",
            lineHeight: 1.7,
          }}
        >
          {children}
        </div>
        <button
          className="btn btn-primary"
          style={{ width: "100%", marginTop: 24 }}
          onClick={onClose}
        >
          Entendi
        </button>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────
   Termos de Uso
───────────────────────────────────────── */
function TermosModal({ onClose }) {
  return (
    <Modal title="Termos de Uso" onClose={onClose}>
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          Última atualização: 2024
        </strong>
      </p>
      <br />
      <p>
        Ao utilizar o jogo <em>Descubra o Impostor</em>, você concorda com estes
        Termos de Uso. Leia com atenção antes de prosseguir.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>1. Uso Permitido</strong>
        <br />
        Este jogo é disponibilizado para entretenimento pessoal e uso entre
        amigos e família. Qualquer uso comercial ou reprodução sem autorização
        é proibido.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          2. Modo Online
        </strong>
        <br />
        O modo online permite que jogadores criem ou entrem em uma sala
        compartilhada remotamente. Não nos responsabilizamos por falhas de
        conexão ou comportamento de terceiros durante partidas.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          3. Conteúdo do Jogo
        </strong>
        <br />
        As perguntas e categorias são geradas para público geral. O jogo não
        contém conteúdo adulto ou ofensivo intencionalmente. Caso encontre algo
        inadequado, entre em contato.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>4. Propagandas</strong>
        <br />
        O jogo pode exibir anúncios de terceiros para manter o serviço gratuito.
        Não somos responsáveis pelo conteúdo dos anúncios exibidos por
        plataformas externas.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          5. Limitação de Responsabilidade
        </strong>
        <br />
        O jogo é fornecido "como está", sem garantias de disponibilidade
        contínua. Não nos responsabilizamos por perdas decorrentes do uso do
        aplicativo.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>6. Alterações</strong>
        <br />
        Reservamos o direito de alterar estes Termos a qualquer momento. O uso
        continuado do jogo após alterações implica aceitação dos novos termos.
      </p>
    </Modal>
  );
}

/* ─────────────────────────────────────────
   Política de Privacidade
───────────────────────────────────────── */
function PrivacidadeModal({ onClose }) {
  return (
    <Modal title="Política de Privacidade" onClose={onClose}>
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          Última atualização: 2024
        </strong>
      </p>
      <br />
      <p>
        A sua privacidade é importante para nós. Esta política explica quais
        dados coletamos (ou não coletamos) ao usar o{" "}
        <em>Descubra o Impostor</em>.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          1. Dados que NÃO coletamos
        </strong>
        <br />
        No modo local, nenhum dado pessoal é enviado a servidores. Os nomes dos
        jogadores e as respostas ficam apenas no seu dispositivo e são
        descartados ao fechar o jogo.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          2. Modo Online
        </strong>
        <br />
        No modo online, coletamos: apelido do jogador, código da sala e dados
        de sessão temporários necessários para a partida. Esses dados são
        excluídos após o término da sessão.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>3. Anúncios</strong>
        <br />
        Parceiros de publicidade podem utilizar cookies e tecnologias similares
        para exibir anúncios relevantes. Consulte a política de privacidade de
        cada parceiro para mais detalhes.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>4. Cookies</strong>
        <br />
        Utilizamos apenas cookies estritamente necessários para o funcionamento
        do jogo (ex.: preferência de tema). Não utilizamos cookies de
        rastreamento próprios.
      </p>
      <br />
      <p>
        <strong style={{ color: "var(--text-primary)" }}>
          5. Contato
        </strong>
        <br />
        Para exercer seus direitos de privacidade ou tirar dúvidas, entre em
        contato pelo suporte disponível no site oficial.
      </p>
    </Modal>
  );
}

/* ─────────────────────────────────────────
   Home Screen principal
───────────────────────────────────────── */
export default function HomeScreen({ onSelectLocal, onSelectOnline }) {
  const [modal, setModal] = useState(null); // 'termos' | 'privacidade' | null

  return (
    <>
      {modal === "termos" && <TermosModal onClose={() => setModal(null)} />}
      {modal === "privacidade" && (
        <PrivacidadeModal onClose={() => setModal(null)} />
      )}

      <div className="app-wrapper" style={{ paddingTop: 88, paddingBottom: 24 }}>
        {/* Banner de propaganda topo */}
        <AdBanner id="ad-top" style={{ marginBottom: 20 }} />

        <div className="card" style={{ maxWidth: 420 }}>
          <div className="card-header">
            <div className="title-eyebrow">🎮 Escolha o modo</div>
            <h1 className="title-main">
              Como quer
              <br />
              <span style={{ color: "var(--accent)" }}>jogar?</span>
            </h1>
            <p className="title-sub">
              Selecione o modo de partida para começar.
            </p>
          </div>

          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            {/* Modo Local */}
            <button
              className="mode-card"
              onClick={onSelectLocal}
              style={{
                background: "var(--bg-elevated)",
                border: "2px solid var(--border)",
                borderRadius: 16,
                padding: "20px 20px",
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 16,
                transition: "border-color 0.2s, box-shadow 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "var(--accent)";
                e.currentTarget.style.boxShadow = "var(--shadow-glow)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--border)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  fontSize: "2.4rem",
                  background: "var(--accent-dim)",
                  borderRadius: 12,
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                🖥️
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "'Bebas Neue'",
                    fontSize: "1.4rem",
                    letterSpacing: "0.06em",
                    color: "var(--text-primary)",
                  }}
                >
                  Modo Local
                </div>
                <div
                  style={{
                    fontSize: "0.78rem",
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  Jogue com amigos no mesmo dispositivo
                </div>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  color: "var(--accent)",
                  fontSize: "1.2rem",
                }}
              >
                →
              </div>
            </button>

            {/* Modo Online */}
            <button
              className="mode-card"
              onClick={onSelectOnline}
              style={{
                background: "var(--bg-elevated)",
                border: "2px solid var(--border)",
                borderRadius: 16,
                padding: "20px 20px",
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 16,
                transition: "border-color 0.2s, box-shadow 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "var(--purple)";
                e.currentTarget.style.boxShadow =
                  "0 0 0 4px color-mix(in srgb, var(--purple) 20%, transparent)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "var(--border)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  fontSize: "2.4rem",
                  background: "var(--purple-dim)",
                  borderRadius: 12,
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                🌐
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "'Bebas Neue'",
                    fontSize: "1.4rem",
                    letterSpacing: "0.06em",
                    color: "var(--text-primary)",
                  }}
                >
                  Modo Online
                </div>
                <div
                  style={{
                    fontSize: "0.78rem",
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  Jogue com amigos à distância, cada um no seu celular
                </div>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  color: "var(--purple)",
                  fontSize: "1.2rem",
                }}
              >
                →
              </div>
            </button>
          </div>

          <div className="card-footer" style={{ flexDirection: "column", gap: 12 }}>
            {/* Slot de propaganda entre conteúdo */}
            <AdBanner id="ad-card" style={{ marginBottom: 4 }} />

            {/* Links legais */}
            <div
              style={{
                display: "flex",
                gap: 16,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={() => setModal("termos")}
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--text-muted)",
                  fontSize: "0.72rem",
                  fontFamily: "'Space Mono'",
                  cursor: "pointer",
                  textDecoration: "underline",
                  letterSpacing: "0.02em",
                }}
              >
                Termos de Uso
              </button>
              <span style={{ color: "var(--text-muted)", fontSize: "0.72rem" }}>
                •
              </span>
              <button
                onClick={() => setModal("privacidade")}
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--text-muted)",
                  fontSize: "0.72rem",
                  fontFamily: "'Space Mono'",
                  cursor: "pointer",
                  textDecoration: "underline",
                  letterSpacing: "0.02em",
                }}
              >
                Política de Privacidade
              </button>
            </div>

            {/* Desenvolvedor */}
            <button
              onClick={() => window.open("https://vitornorton.com.br", "_blank")}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                padding: "2px 0",
              }}
            >
              <span style={{
                fontFamily: "'Space Mono'",
                fontSize: "0.62rem",
                color: "var(--text-muted)",
                letterSpacing: "0.08em",
              }}>
                &gt;_
              </span>
              <svg
                viewBox="0 0 180 180"
                style={{ width: 13, height: 13, fill: "var(--text-muted)", flexShrink: 0 }}
                xmlns="http://www.w3.org/2000/svg"
              >
                <g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
                  <path d="M460 1533 c0 -5 20 -43 44 -85 l44 -78 -182 -2 -182 -3 275 -508
                    c245 -450 277 -506 289 -490 7 10 27 44 44 76 17 31 34 57 37 57 4 0 47 -74
                    96 -164 49 -91 91 -164 92 -162 5 5 553 1017 553 1022 0 2 -84 5 -187 6 -109
                    1 -146 4 -87 5 l100 4 82 158 c45 87 82 161 82 165 0 3 -247 6 -550 6 -302 0
                    -550 -3 -550 -7z m875 -73 l-35 -70 -288 0 -288 0 -27 63 c-15 34 -27 65 -27
                    70 0 4 158 7 350 7 l350 0 -35 -70z m-177 -87 c-75 -2 -201 -2 -280 0 -79 1
                    -17 3 137 3 154 0 218 -2 143 -3z m-588 -83 c16 -33 30 -62 30 -64 0 -3 -38
                    -7 -85 -8 l-84 -3 151 -277 c83 -153 155 -278 159 -278 4 0 25 32 45 70 21 39
                    41 70 44 70 7 0 70 -108 70 -121 0 -12 -150 -288 -160 -294 -5 -3 -280 495
                    -498 903 l-33 62 165 0 166 0 30 -60z m674 28 c-9 -18 -64 -122 -122 -231
                    l-104 -199 -39 69 -38 68 50 93 c27 51 49 95 49 97 0 3 -47 5 -104 5 l-103 0
                    -32 59 c-17 32 -31 62 -31 65 0 3 110 6 245 6 l246 0 -17 -32z m-629 -67 l18
                    -40 190 -1 c104 0 192 -2 195 -5 3 -3 0 -11 -8 -18 -10 -9 -11 -9 -6 1 6 9
                    -50 12 -263 12 -149 0 -271 -2 -271 -5 0 -4 7 -19 15 -35 9 -17 13 -30 10 -30
                    -2 0 -14 18 -25 40 l-20 40 85 0 c47 0 85 2 85 5 0 3 -9 24 -21 46 -11 23 -16
                    39 -11 36 4 -4 17 -24 27 -46z m365 -76 c0 -3 -14 -32 -30 -65 l-30 -60 -105
                    0 c-58 0 -105 -3 -105 -6 0 -3 23 -50 52 -103 l52 -97 -38 -63 -38 -62 -80
                    148 c-44 81 -100 185 -124 231 l-45 82 245 0 c136 0 246 -2 246 -5z m304 -482
                    c-145 -267 -265 -487 -267 -489 -1 -1 -39 66 -85 149 l-83 151 32 61 c17 33
                    35 63 38 68 4 4 26 -29 50 -74 24 -44 47 -77 51 -72 4 4 75 133 158 286 l150
                    277 -89 0 c-49 0 -89 2 -89 5 0 3 14 32 30 65 l30 60 169 0 169 0 -264 -487z
                    m-129 407 c-14 -27 -25 -52 -25 -55 0 -3 38 -5 85 -5 47 0 85 -3 85 -7 0 -5
                    -43 -7 -95 -5 l-95 3 30 60 c17 32 33 59 35 59 3 0 -6 -22 -20 -50z m-610 -50
                    c9 -16 13 -30 11 -30 -3 0 -12 14 -21 30 -9 17 -13 30 -11 30 3 0 12 -13 21
                    -30z m388 -32 c6 -21 5 -22 -8 -5 -11 16 -26 18 -104 15 -50 -2 -91 0 -91 5 0
                    4 44 7 99 7 94 0 99 -1 104 -22z m-163 -48 c6 -11 8 -20 6 -20 -3 0 -10 9 -16
                    20 -6 11 -8 20 -6 20 3 0 10 -9 16 -20z m-160 -40 c6 -11 8 -20 6 -20 -3 0
                    -10 9 -16 20 -6 11 -8 20 -6 20 3 0 10 -9 16 -20z m306 -226 c57 -103 102
                    -189 100 -191 -2 -2 -23 32 -47 76 -38 72 -44 78 -56 63 -13 -15 -13 -15 -3 5
                    9 19 4 34 -31 95 -22 40 -46 76 -52 80 -7 4 -9 8 -4 8 4 0 0 15 -9 33 -9 17
                    -13 29 -9 25 4 -4 54 -91 111 -194z m-116 76 c-6 -11 -13 -20 -16 -20 -2 0 0
                    9 6 20 6 11 13 20 16 20 2 0 0 -9 -6 -20z m-37 -65 c-9 -19 -18 -33 -21 -31
                    -4 5 26 66 33 66 3 0 -3 -16 -12 -35z m107 -145 c-6 -11 -13 -20 -16 -20 -2 0
                    0 9 6 20 6 11 13 20 16 20 2 0 0 -9 -6 -20z"/>
                </g>
              </svg>
              <span style={{
                fontFamily: "'Space Mono'",
                fontSize: "0.62rem",
                color: "var(--text-muted)",
                fontWeight: 700,
                letterSpacing: "0.05em",
              }}>
                Vitor Norton
              </span>
            </button>
          </div>
        </div>

        {/* Banner inferior */}
        <AdBanner id="ad-bottom" style={{ marginTop: 20 }} />
      </div>
    </>
  );
}
